import React, {PropsWithChildren} from 'react';

const PageContent: React.FC<PropsWithChildren & {fullscreen?: boolean}> = ({
  children,
  fullscreen = true
}) => {
  return (
    <div className="page">
      <div className={`pageContent ${fullscreen ? '' : 'noFullscreen'}`}>
        {children}
      </div>
    </div>
  );
};

export default PageContent;
